import {Grid} from '@mui/material';

import {CompanyDepartments} from '../../../../../../features/company/settings/components/CompanyDepartments/CompanyDepartments';

export const CompanyDepartmentsTab = () => {
  return (
    <Grid container>
      <Grid item xs={12} marginBottom={4}>
        <CompanyDepartments />
      </Grid>
    </Grid>
  );
};
